import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "project-definition-data-structure"
    }}>{`Project Definition Data Structure`}</h1>
    <p>{`The project definition data structure is used to communicate project rules to the API. This data structure defines the raw logic that is used to layout a workspace project. The project definition is a hierarchical data structure of workspaces, panels, and other properties that are used to define the project. Workspace in the CJA UI defines these rules and can be a useful tool for creating and understanding how projects are structured.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Adobe may add optional request and response members (name/value pairs) to existing API objects at any time and without notice or changes in versioning. Adobe recommends that you refer to the API documentation of any third-party tool you integrate with our APIs so that such additions are ignored in processing if not understood. If implemented properly, such additions are non-breaking changes for your implementation. Adobe will not remove parameters or add required parameters without first providing standard notification through release notes.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`The following example is a very simple report to show all visits noted under a specific report suite for the last month.  As you can see, even though it's a very simple report, the definition is very large.  It is suggested that creating Workspace Projects be done in the CJA UI, and the `}<inlineCode parentName="p">{`/projects`}</inlineCode>{` endpoints be used to update or copy projects in simple ways.`}</p>
    <p>{`If creating a project through the API is required, make sure to utilize the `}<inlineCode parentName="p">{`/projects/validate`}</inlineCode>{` endpoint, as described in the `}<a parentName="p" {...{
        "href": "index.md"
      }}>{`Projects Guide`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "definition": {
    "additionalCuratedComponents": [],
    "colorScheme": {
      "id": "default",
      "label": "",
      "value": [
        "#00C0C7",
        "#5144D3",
        "#E8871A",
        "#DA3490",
        "#9089FA",
        "#47E26F",
        "#2780EB",
        "#6F38B1",
        "#DFBF03",
        "#CB6F10",
        "#268D6C",
        "#9BEC54",
        "#5EABFA",
        "#BE40CC",
        "#F56BB7",
        "#FEE02D"
      ]
    },
    "countRepeatInstances": true,
    "currentWorkspaceIndex": 0,
    "customColorSchemes": [],
    "isCurated": false,
    "version": "31",
    "viewDensity": "expanded",
    "workspaces": [
      {
        "id": "3B1FE317-C72A-4983-ABF1-D3BD14A8D511",
        "name": "",
        "panels": [
          {
            "annotations": [],
            "collapsed": false,
            "dateRange": {
              "id": "thisMonth",
              "__entity__": true,
              "type": "DateRange",
              "__metaData__": {
                "name": "This month"
              }
            },
            "description": "",
            "id": "C0DACAE8-CCE1-4332-9496-ABDBE80C9C23",
            "name": "Freeform",
            "position": {
              "autoHeight": 374,
              "autoSize": true,
              "width": 100,
              "x": 0,
              "y": 0
            },
            "reportSuite": {
              "id": "dv_000000000000000000",
              "__entity__": true,
              "type": "ReportSuite",
              "__metaData__": {
                "name": "dv name",
                "rsid": "dv_000000000000000000"
              }
            },
            "segmentGroups": [],
            "subPanels": [
              {
                "collapsed": false,
                "description": "",
                "id": "F2AAAA88-E63E-4AB6-9090-3612F378B9F0",
                "isQuickInsightsSubPanel": false,
                "linkedSourceId": "",
                "position": {
                  "autoHeight": 222,
                  "autoSize": true,
                  "width": 100,
                  "x": 0,
                  "y": 0
                },
                "reportlet": {
                  "advancedMode": false,
                  "advancedSettings": {
                    "rows": [],
                    "tableState": "builder"
                  },
                  "columnTree": {
                    "_computedValues": [],
                    "dataSettings": {
                      "advancedItemLimit": 5,
                      "advancedItemSearch": {
                        "operator": "AND",
                        "rules": []
                      }
                    },
                    "id": "f46df4-2",
                    "name": "",
                    "nodes": [
                      {
                        "_computedValues": [],
                        "component": {
                          "id": "All_Visits",
                          "__entity__": true,
                          "type": "Segment",
                          "__metaData__": {
                            "name": "All Visits"
                          }
                        },
                        "dataSettings": {
                          "advancedItemLimit": 5,
                          "advancedItemSearch": {
                            "operator": "AND",
                            "rules": []
                          }
                        },
                        "id": "f46df4-4",
                        "name": "All Visits",
                        "nodes": [],
                        "selectionCoordinates": [],
                        "tableCellDisplay": {
                          "conditionalFormattingOpts": {
                            "autoGenerate": true,
                            "usePercentLimits": false
                          },
                          "location": "behindNumber",
                          "type": {
                            "anomaly": true,
                            "background": true,
                            "backgroundType": "bar",
                            "comparison": "none",
                            "interpretZeroAsNoValue": false,
                            "number": true,
                            "percent": true,
                            "showGrandTotal": true,
                            "showSparklines": true,
                            "showTotals": true,
                            "wrapHeaderText": true
                          }
                        }
                      }
                    ],
                    "selectionCoordinates": [],
                    "tableCellDisplay": {
                      "conditionalFormattingOpts": {
                        "autoGenerate": true,
                        "usePercentLimits": false
                      },
                      "location": "behindNumber",
                      "type": {
                        "anomaly": true,
                        "background": true,
                        "backgroundType": "bar",
                        "comparison": "none",
                        "interpretZeroAsNoValue": false,
                        "number": true,
                        "percent": true,
                        "showGrandTotal": true,
                        "showSparklines": true,
                        "showTotals": true,
                        "wrapHeaderText": true
                      }
                    }
                  },
                  "freeformTable": {
                    "alignDatesForTimeDimension": true,
                    "attributionSettings": [],
                    "breakdowns": [],
                    "collapsed": false,
                    "columnWidths": [
                      100,
                      100
                    ],
                    "pagination": {
                      "currentPage": 0,
                      "viewBy": 50
                    },
                    "search": {
                      "operator": "AND",
                      "rules": []
                    },
                    "selectionCoordinates": [],
                    "settings": {
                      "breakdownByPosition": false,
                      "rowBasedPercentages": false,
                      "totalsType": "columnSum"
                    },
                    "sort": {
                      "asc": false,
                      "columnId": "f46df4-4",
                      "labelColumn": false
                    },
                    "staticRows": [
                      {
                        "component": {
                          "id": "metrics/visits",
                          "__entity__": true,
                          "type": "Metric",
                          "__metaData__": {
                            "name": "Visits"
                          }
                        },
                        "dataSettings": {
                          "advancedItemLimit": 5,
                          "advancedItemSearch": {
                            "operator": "AND",
                            "rules": []
                          }
                        },
                        "id": "f46df4-a"
                      }
                    ],
                    "statistics": {
                      "functions": [],
                      "ignoreZeros": true
                    }
                  },
                  "isConfigVisible": true,
                  "type": "FreeformReportlet"
                },
                "swatchColor": "#00C0C7",
                "type": "genericSubPanel",
                "visible": true,
                "visualizationIndex": 1
              }
            ],
            "type": "panel"
          }
        ]
      }
    ]
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      